<div class="app-launcher-wrapper">
  <button
    #launcherTrigger
    pButton
    type="button"
    class="launcher-btn"
    [text]="true"
    [rounded]="true"
    aria-label="Open app launcher"
    [class.active]="isOpen"
    (click)="launcherPopover.toggle($event)"
  >
    <svg class="launcher-dots-icon" width="16" height="16" viewBox="0 0 20 20" aria-hidden="true">
      <circle cx="3" cy="3" r="2" />
      <circle cx="10" cy="3" r="2" />
      <circle cx="17" cy="3" r="2" />
      <circle cx="3" cy="10" r="2" />
      <circle cx="10" cy="10" r="2" />
      <circle cx="17" cy="10" r="2" />
      <circle cx="3" cy="17" r="2" />
      <circle cx="10" cy="17" r="2" />
      <circle cx="17" cy="17" r="2" />
    </svg>
  </button>

  <p-popover
    #launcherPopover
    appendTo="body"
    [dismissable]="true"
    styleClass="launcher-popover"
    (onShow)="onPopoverShow()"
    (onHide)="onPopoverHide()"
  >
    <section #launcherGrid aria-label="App launcher">
      <div class="launcher-section-label">Modules</div>
      <div class="launcher-grid">
        @for (item of visibleModules; track item.label) {
          <button
            type="button"
            class="launcher-item"
            [disabled]="item.disabled"
            (click)="navigate(item)"
            [attr.title]="item.title ?? item.label"
          >
            @if (item.svgPath) {
              <svg class="launcher-item__svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
                <path [attr.d]="item.svgPath" />
              </svg>
            } @else {
              <i [class]="item.icon" aria-hidden="true"></i>
            }
            <span>{{ item.label }}</span>
          </button>
        }
      </div>

      @if (visibleAdminModules.length) {
        <hr class="launcher-divider" />
        <div class="launcher-section-label">Administration</div>
        <div class="launcher-grid">
          @for (item of visibleAdminModules; track item.label) {
            <button type="button" class="launcher-item" [disabled]="item.disabled" (click)="navigate(item)" [attr.title]="item.label">
              <span class="launcher-icon-wrap">
                <i [class]="item.icon" aria-hidden="true"></i>
                <i class="pi pi-lock launcher-badge" aria-label="Admin"></i>
              </span>
              <span>{{ item.label }}</span>
            </button>
          }
        </div>
      }
    </section>
  </p-popover>
</div>
